import getBookmakersConfig from '../common/bookmakersList/bookmakers'
import { actions as bookmakersInfoActions } from '../common/bookmakersInfo'
import { actions as betActions } from '../common/bet'

const bookmakers = getBookmakersConfig()

export const actionTypes = {
    MINIMIZE_DRAWER: 'MINIMIZE_DRAWER',
    MAXIMIZE_DRAWER: 'MAXIMIZE_DRAWER',
    SET_THEME: 'SET_THEME',
    SET_QUICKSLIP_MODE: 'SET_QUICKSLIP_MODE',
};

export const minimizeDrawer = () => ({
    type: actionTypes.MINIMIZE_DRAWER,
});

export const maximizeDrawer = () => ({
    type: actionTypes.MAXIMIZE_DRAWER,
});

export const setTheme = theme => ({
    type: actionTypes.SET_THEME,
    theme,
})

export const setThemeFromBookieName = bookieName => (dispatch) => {
    const bookmaker = bookmakers.find((bookie) => bookie.feed === bookieName);
    const theme = (bookmaker !== undefined) ? bookmaker.name : 'no-bookmaker';
    dispatch(setTheme(theme));
}

export const setQuickslipMode = enabled => ({
    type: actionTypes.SET_QUICKSLIP_MODE,
    enabled,
})

export const resetEmptyBetslip = () => (dispatch) => {
    dispatch(setQuickslipMode(true))
    dispatch(minimizeDrawer())
}

export const resetQuickslip = () => (dispatch) => {
    dispatch(bookmakersInfoActions.clearSelectedBets())
    dispatch(setQuickslipMode(true))
    dispatch(betActions.setBetObstruction(betActions.betObstructions.NONE));
    dispatch(bookmakersInfoActions.clearGenericError());
    dispatch(minimizeDrawer())
}

export const clickOutsideBetslip = (isQuickslipMode, numberOfBets) => (dispatch) => {
    // Note that for any outcome, the drawer will be minimized
    if (isQuickslipMode) {
        dispatch(resetQuickslip())
    } else {
        const action = (numberOfBets === 0)
            ? resetEmptyBetslip()
            : minimizeDrawer()
        dispatch(action)
    }
}

export const minimizeQuickslip = () => (dispatch) => {
    dispatch(setQuickslipMode(false))
    dispatch(minimizeDrawer())
}



// WEBPACK FOOTER //
// /src/js/drawer/drawer.actions.js